// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__MmD7W","image":"Header_image__3pegU","name":"Header_name__3sdke","info":"Header_info__YiK6G","infoRow":"Header_infoRow__3a7m2"};